import { Controller } from '@hotwired/stimulus'

const CON_FRANJA = 'rnk-Comparativa_Caja-conFranja'
const VISIBLE = 'rnk-Comparativa_Franja-visible'
// Lo que mide la franja, de sobra: antes de que el final de la tabla llegue a ella, se va.
const ALTO_FRANJA = 64

// La cabecera de la comparativa de ETFs (`_comparar_tabla.haml`), con gestora, nombre y ticker, llega a 160 px
// con cuatro ETFs: fija arriba al bajar se comía la pantalla. Con JS deja de ser fija y, cuando sale por arriba,
// aparece en su lugar una franja de una línea con la muestra y el ticker de cada uno, hasta que se acaba la tabla.
// Se observan la cabecera y la caja y no el scroll, como en `comparar_barra_controller.js`. Sin JS sigue fija la
// cabecera entera.
export default class extends Controller {
  static targets = ['cabecera', 'franja']

  connect () {
    this.element.classList.add(CON_FRANJA)
    this.cabeceraPasada = false
    this.cajaALaVista = false

    // Debajo de la cabecera del sitio cuando es fija: el mismo `top` que pone el SCSS a la franja.
    const arriba = parseFloat(getComputedStyle(this.franjaTarget).top) || 0
    this.observadores = [
      this.observa(this.cabeceraTarget, arriba, entrada => {
        this.cabeceraPasada = !entrada.isIntersecting && entrada.boundingClientRect.top < arriba
      }),
      this.observa(this.element, arriba + ALTO_FRANJA, entrada => { this.cajaALaVista = entrada.isIntersecting })
    ]
  }

  disconnect () {
    this.observadores.forEach(observador => observador.disconnect())
    this.element.classList.remove(CON_FRANJA)
    this.franjaTarget.classList.remove(VISIBLE)
  }

  observa (elemento, margen, cambia) {
    const observador = new IntersectionObserver(([entrada]) => {
      cambia(entrada)
      this.franjaTarget.classList.toggle(VISIBLE, this.cabeceraPasada && this.cajaALaVista)
    }, { rootMargin: `-${margen}px 0px 0px 0px` })
    observador.observe(elemento)
    return observador
  }
}
